import { getStsToken } from "@/api/app"
import store from "@/store"

let OSS = require("ali-oss")

let client

// 初始化 OSS client 对象
export function createOssClient(params) {
  client = new OSS({
    region: params.region,
    accessKeyId: params.accessKeyId,
    accessKeySecret: params.accessKeySecret,
    stsToken: params.securityToken,
    bucket: params.bucket,
    secure: true
  })
}

// 初始化 OSS client
export function initOssClient() {
  if (store.getters.isTemplateMode) {
    return Promise.reject("模板预览模式无法上传文件")
  }
  return getStsToken().then(res => {
    let data = {
      ...res.data.data,
      region: "oss-cn-hangzhou",
      bucket: "new-service"
    }
    delete data.expiration
    createOssClient(data)
    return { code: 0, data }
  })
}

/*
  objectName 可以自定义为文件名（例如file.txt）
  或目录（例如abc/test/file.txt）的形式。
*/
/*
  interface PutObjectOptions {
    timeout?: number; // the operation timeout
    mime?: string; // custom mime, will send with Content-Type entity header
    meta?: UserMeta; // user meta, will send with x-oss-meta- prefix string e.g.: { uid: 123, pid: 110 }
    callback?: ObjectCallback;
    headers?: object;
  }
*/

// 上传数据
export function put(objectName, localFile, options = {}) {
  return client.put(objectName, localFile, options)
}

// 获取数据
export function get(objectName) {
  return client.get(objectName)
}

// 给数据签名(若数据是private,则无法公共读，需签名)
export async function signature({ objectName, downloadName } = {}) {
  let fileName
  if (downloadName) fileName = downloadName
  else fileName = objectName.slice(objectName.indexOf("/") + 1)
  let url = client.signatureUrl(objectName, {
    expires: 3600,
    response: {
      "content-disposition": `attachment;filename="${fileName}"`
    }
  })
  return url
}

// 删除数据
export function del(objectName) {
  return client.delete(objectName)
}

/*
  [progress] {Function}： async 函数形式。回调函数包含三个参数：
  percentage {Number}：进度百分比（0-1之间小数）
  checkpoint {Object}：断点记录点
  res {Object}：单个分片成功返回的 response
*/
export async function resumeUpload(objectName, localFile, options = {}) {
  let checkpoint = null
  for (let i = 0; i < 5; i++) {
    try {
      const result = await client.multipartUpload(
        objectName,
        localFile,
        Object.assign(
          {
            checkpoint,
            async progress(percentage, cpt) {
              checkpoint = cpt
            }
          },
          options
        )
      )
      return result
    } catch (e) {
      console.log(e)
    }
  }
  return false
}

export function download({ objectName, downloadName } = {}) {
  return signature({ objectName, downloadName }).then(res => {
    window.open(res)
  })
}

// 流式下载：一次处理部分内容，直到完成文件的下载
// 要下载的文件太大，或者一次性下载耗时太长时使用
// export async function getStream() {
//   try {
//     let result = await client.getStream("object-name")
//     console.log(result)
//     let writeStream = fs.createWriteStream("local-file")
//     result.stream.pipe(writeStream)
//   } catch (e) {
//     console.log(e)
//   }
// }
